export default {
	store: {
		code: 'RCT',
		description: 'Recojo en tienda',
		value: 2,
	},
	house: {
		code: 'EAD',
		description: 'Envío a Domicílio',
		value: 1,
	},
};



// WEBPACK FOOTER //
// ./src/shared/enums/waysDeliveries.js